import React from 'react';
import { Select } from 'antd';
import { SelectProps } from 'antd/lib/select';
import { noop } from 'lodash';

import {
  getParPrintListByCriteria,
  GetParPrintListByCriteriaParams,
  ParPrintResponse,
} from 'services/printingService';
import { useQuery } from 'react-query';

const { Option } = Select;

export type DocSelectProps = SelectProps<any> & {
  onSelected?: (Print: ParPrintResponse) => void;
  entity?: string;
  type?: string;
  style?: React.CSSProperties;
};

const DocCodePrintSelect = ({
  value,
  entity,
  type,
  style,
  onChange = noop,
  onSelected,
  ...rest
}: DocSelectProps) => {
  const params: GetParPrintListByCriteriaParams = {
    contenttype: '',
    doccode: '',
    docmodule: entity ?? '',
    docstatus: '',
    doctemplate: '',
    prcode: '',
    printtype: type ?? 'PDF',
  };
  const { data: listeParPrint } = useQuery(
    ['getParPrintListByCriteria', params],
    () => getParPrintListByCriteria(params).then((res) => res.list || [])
  );
  const handleChange: SelectProps<any>['onChange'] = (value, option) => {
    onChange(value, option);
    if (onSelected) {
      onSelected(listeParPrint?.find((item) => item.doccode === value)!);
    }
  };

  return (
    <Select onChange={handleChange} value={value} style={style} {...rest}>
      {listeParPrint?.map((item, index) => (
        <Option key={index} value={item.doccode}>
          {item.doclabel}
        </Option>
      ))}
    </Select>
  );
};

export default DocCodePrintSelect;
